import { marginBottom } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  ${marginBottom(4)};
`;
